module.exports = __webpack_public_path__ + "img/search.59cb6553.png";